// Wähle das Ziel-Div aus


document.addEventListener('DOMContentLoaded', () => {
  const body = document.body; // Body-Element auswählen
  const targetDiv = document.querySelector('.collection-banner__wrapper'); // Ziel-Div auswählen

  if (targetDiv) {
    const imgElement = document.createElement('img'); // Neues Bild-Element erstellen

    if (body.classList.contains('template-collection-berufsmode')) {
      imgElement.src = 'https://cdn.shopify.com/s/files/1/0864/4673/5704/files/enrico_wieland_schwarz.png?v=1727248188';
      imgElement.alt = 'Logo Berufsmode';
      imgElement.className = 'logo-kategorie-header beruf';
    } else if (body.classList.contains('template-collection-privatmode')) {
      imgElement.src = '/cdn/shop/files/alex_wieland.png?v=1727248203';
      imgElement.alt = 'Logo Privatmode';
      imgElement.className = 'logo-kategorie-header privat';
    } else if (body.classList.contains('template-collection-home-und-deko')) {
      imgElement.src = 'https://cdn.shopify.com/s/files/1/0864/4673/5704/files/Exclusiv_Wohnen_Logo_2_frei.png?v=1767894060';
      imgElement.alt = 'Logo Hoem & Deko';
      imgElement.className = 'logo-kategorie-header home-und-deko';
    } else if (body.classList.contains('template-collection-wiemobil-camping-outd')) {
      imgElement.src = 'https://cdn.shopify.com/s/files/1/0864/4673/5704/files/Wiemobil_Logo_2025.png?v=1735948070';
      imgElement.alt = 'Logo Wiemobil';
      imgElement.className = 'logo-kategorie-header mobil';
    } else {
      console.error('Keine passende Klasse gefunden.');
      return; // Abbrechen, wenn keine passende Klasse gefunden wird
    }

    imgElement.style.maxWidth = '100%'; // Optional: Stil für das Bild
    targetDiv.appendChild(imgElement); // Bild in das Ziel-Div einfügen
  } else {
    console.error('Das Ziel-Element wurde nicht gefunden.');
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const el = document.querySelector(".container.container-collection-description .collection-description.rte");

    if (!el) return;

    const maxHeight = 500;

    // Check if content exceeds max height
    if (el.scrollHeight <= maxHeight) return;

    // Apply collapsed state
    el.classList.add("collection-description-collapsed", "collection-description-fade");

    // Create button
    const btn = document.createElement("div");
    btn.className = "read-more-btn";
    btn.innerText = "Mehr lesen";

    el.after(btn);

    let isOpen = false;

    btn.addEventListener("click", function () {
        if (!isOpen) {
            el.classList.remove("collection-description-collapsed", "collection-description-fade");
            el.classList.add("collection-description-expanded");
            btn.innerText = "Weniger lesen";
        } else {
            el.classList.remove("collection-description-expanded");
            el.classList.add("collection-description-collapsed", "collection-description-fade");
            btn.innerText = "Mehr lesen";

            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        isOpen = !isOpen;
    });
});